import Vue from 'vue';

/** Event bus for sending panel events. */
const PanelEventBus = new Vue();

export default PanelEventBus;
